export default __webpack_public_path__ + "static/media/downloadXml.574fdb1e.svg";